// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"20cd59488f529e8ad2ec","678":"8bfeaffcf8aa467840e6","883":"5693fe1361ed600f8b04"}[chunkId] + ".js";
};